import React from 'react';
import cls from 'classnames';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';

import './index.scss';

export type IGridColumns<T = any> = {
  key: string;
  title: string;
  title_cn: string;
  align?: 'start' | 'center' | 'end';
  width?: number;
  width_cn?: number;
  render?: (item: T) => React.ReactNode;
}[];

interface IGridColumnProps {
  columns: IGridColumns;
  data: any[];
}

const GridColumn = ({ columns, data }: IGridColumnProps) => {
  const { formatMessage, isEN } = useIntlExtend();

  return (
    <div className="dbi_column_container" style={{ flex: 1 }}>
      <div className="dbi_column_data_container">
        {Boolean(data?.length) &&
          columns?.map((column: any, index: number) => {
            const width = (isEN ? column.width : column.width_cn) || column.width;
            return (
              <div key={index} style={{ width: data?.length ? width : width || '20%' }}>
                {/* 表头 */}
                <div
                  className={cls('dbi_column_title', {
                    dbi_column_title_align_center: column.align === 'center',
                  })}
                  style={{
                    // 首列表头无配置宽度，随机指定固定宽度，避免定位元素宽度无法撑开显示底部滚动元素
                    width: index ? width : '20%',
                  }}
                >
                  {isEN ? column.title : column.title_cn}
                </div>
                {/* 渲染列表 */}
                {data?.map((item: any, index) => {
                  return (
                    <div
                      className="dbi_column_item_container"
                      key={index}
                      style={{
                        width,
                        justifyContent: column.align,
                      }}
                    >
                      {column.render ? column.render(item) : item[column.key]}
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
      {/* 无数据 */}
      {!data?.length && (
        <div className="dbi_game_info_languages_card_no_data">
          {formatMessage({ id: 'dbi_search_empty' })}
        </div>
      )}
    </div>
  );
};

export default GridColumn;
